import FilterType from './filterType';
import valueIn from '../../utils/valueIn';

export default FilterType({
    id: 'PRICE',
    filterFunction: (allHotelIds, filterTree, currentFilterValues, segmentationState, filterId, hotels) => {
    // Block EVERYTHING not in range
    // Match EVERYTHING in range
    // Potentials = EVERYTHING that is not BLOCKED

        const isHotelInPriceRange = {};
        let isFilterActive = false;

        const selectedAmount = valueIn(currentFilterValues, 'selectedAmount.value');
        const maximumPrice = valueIn(currentFilterValues, 'maximumPrice');

        if (selectedAmount === 0 || (selectedAmount && selectedAmount < maximumPrice)) {
            isFilterActive = true;

      // The bucket will contain ALL hotelIds that have prices
            const bucket = valueIn(filterTree, [filterId, 'hasPrice']) || [];

            bucket.forEach((hotelId) => {
                const hotelData = valueIn(hotels, [`${hotelId}`]);

        // TODO: Price exists here (VERIFY IN THE FILTER --> ONLY SET TO TRUTHY BUCKET IF EXIST)
                const price = valueIn(hotelData, 'priceInfo.filterTotalPrice');

                isHotelInPriceRange[hotelId] = price <= selectedAmount;
            });
        }

        if (!isFilterActive) {
            return 0;
        }

        const pricePotentials = [];

    // NB: We _HAVE_ to go through all hotelIds (not just those that are not blocked) because
    //     a filter can have potentials that are blocked externally but we still may need to block
    //     them from this filter (Filter A blocks hotel X -- but it is in A:s potentials); if this
    //     filter also blocks X, we must remove it from A:s potentials!
        allHotelIds.forEach((hotelId) => {
            const isInRange = isHotelInPriceRange[hotelId];

            if (!segmentationState.block[hotelId]) {
        // Everything that is not blocked will be a potential (even if we block it externally)
                pricePotentials.push(hotelId);
            }

            if (isInRange) {
        // Stuff that matches
                segmentationState.match[hotelId] = !segmentationState.block[hotelId];
            } else if (!isInRange) {
        // Stuff we block for others
                segmentationState.match[hotelId] = false;
                segmentationState.block[hotelId] = true;

                Object.keys(segmentationState.potentials).forEach((potentialsFilterId) => {
                    if (segmentationState.potentials[potentialsFilterId][hotelId]) {
                        segmentationState.potentials[potentialsFilterId][hotelId] = false; // This filter blocks another filters potential
                    }
                });
            }
        });

        segmentationState.potentials[filterId] = {};
        pricePotentials.forEach((hotelId) => {
            segmentationState.potentials[filterId][hotelId] = true;
        });

        return 1;
    },
});
